<div
  data-test="7X6AlyUD"
  class="ui-kit-c"
  *ngFor="let color of palette"
  [ngStyle]="{ 'background-color': color.value }"
  [ngClass]="{ 'ui-kit-c_light': isLight(color.value) }"
>
  <div data-test="t7HINF9V">{{ color.color }}</div>
  <div data-test="OGdv7vcU">{{ color.value }}</div>
</div>
